export default __webpack_public_path__ + "static/media/error404.9ccda1b1.svg";